import React from 'react'

function LogIn({login,isError}) {
    const [loginForm, setLoginForm] = React.useState({
        email: '',
        password: ''
    })

    const handleChange = (e) => {
        setLoginForm({...loginForm, [e.target.name]: e.target.value})
    }

    const handleLogin =(e)=>{
        e.preventDefault();
        console.log(loginForm);
        login(loginForm.email,loginForm.password)
    }
    return (
      <div className="adminLoginMain dark flexBox">
        <form className="adminLoginForm flexBox glass" onSubmit={handleLogin}>
          <h1>Login</h1>
          <input
            type="text"
            name="email"
            placeholder="Email"
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            onChange={handleChange}
            required
          />
          {isError && <p>{isError}</p>}
          <button type="submit">Log In</button>
        </form>
      </div>
    );
}

export default LogIn
